import "./App.css";
import Allroutes from "./Components/Allroutes";
import { Login } from "./Components/Login";

function App() {
  return (
    <div className="App">
      <Allroutes />
      {/* <Login /> */}
    </div>
  );
}

export default App;
